'use client'
import { Card, Flex, Text } from '@mantine/core'
import { useNavigation } from '../../auth/NavigationContext'
import { meRoute } from '~/utils/routes'
import { StyledButton } from '../../buttons'

interface NoFolioFooterProps {
  mobile: boolean
}

export function NoFolioFooter({ mobile }: NoFolioFooterProps) {
  const navigation = useNavigation()

  return (
    <Card
      p={mobile ? '10px' : undefined}
      style={{
        backgroundColor: 'f1f1f1',
        width: '100%',
        boxShadow: '0px -4px 6px rgba(0, 0, 0, 0.10), 0px 4px 6px rgba(0, 0, 0, 0.10)',
        borderRadius: '18px',
      }}
    >
      <Flex direction="row" gap="xs" justify="space-between" align="center">
        <Text size={mobile ? '10px' : 'md'} w="70%">
          {mobile
            ? "You're missing a folio. Add one so you can"
            : "You're currently missing a folio. Add one so you can"}{' '}
          <Text
            span
            c="blue"
            style={{ cursor: 'pointer' }}
            onClick={(e) => navigation.navigate({ name: 'nofolio_connect', route: '/', event: e })}
            data-testid="nofolio-connect-link"
          >
            connect with users
          </Text>{' '}
          and{' '}
          <Text
            span
            c="blue"
            style={{ cursor: 'pointer' }}
            onClick={(e) => navigation.navigate({ name: 'nofolio_collaborate', route: '/iso', event: e })}
            data-testid="nofolio-collaborate-link"
          >
            collaborate on shoots
          </Text>
          .
        </Text>

        <StyledButton
          width="20%"
          disablePadding={mobile}
          extraSmallPadding={!mobile}
          noPadding={mobile}
          slimHeight
          text="ADD FOLIO"
          type="primary"
          onClick={(e) => navigation.navigate({ name: 'nofolio_add', route: meRoute().editProfile, event: e })}
          data-testid="nofolio-add-button"
        />
      </Flex>
    </Card>
  )
}
